
//29
Object.defineProperty(exports, "__esModule", { value: true });
require("../dropdown/Dropdown.st.css");
require("../dropdown-option/DropdownOption.st.css");
require("../checkbox/Checkbox.st.css");
require("../deprecated/label/Label.st.css");
require("../deprecated/divider/Divider.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "LabelWithOptions810629981",
    {"root":"LabelWithOptions810629981--root","selection":"LabelWithOptions810629981--selection","label":"LabelWithOptions810629981--label","divider":"LabelWithOptions810629981--divider","placeholder":"LabelWithOptions810629981--placeholder","optionContainer":"LabelWithOptions810629981--optionContainer","checkbox":"LabelWithOptions810629981--checkbox"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/label-with-options/LabelWithOptions.st.css
// module id = 1291
// module chunks = 0